import Vue from 'vue'
import App from './App.vue'
import router from './router'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import VueSweetalert2 from 'vue-sweetalert2';
import axios from 'axios'
import VueAxios from 'vue-axios'
import liff,{getFriendship, getProfile, getAccessToken} from '@line/liff';
import Api from './utils/Api';
import 'sweetalert2/dist/sweetalert2.min.css';
// import style (<= Swiper 5.x)
import 'swiper/css/swiper.css'
Vue.use(VueAxios, axios);
Vue.use(VueAwesomeSwiper,);
Vue.use(VueSweetalert2);

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(ElementUI);

import UdUi from './components/ud-ui';
Vue.use(UdUi);

Vue.config.productionTip = false

let liffId = '';
let lineFriend = '';
let bindUrl ='';

switch (location.host) {
  case 'starlike-test.coolbe.com.tw':
    liffId = '1657228471-zlxW6X88';
    lineFriend ='https://line.me/R/ti/p/@687nrcyc'
    bindUrl ='https://liff.line.me/1657228471-QwV5ljGG'
    break;
  case 'starlike.coolbe.com.tw':
    liffId = '1656334484-2dwBJeY3';
    lineFriend ='https://line.me/R/ti/p/@starlike'
    bindUrl ='https://liff.line.me/1656334484-Pmr0ZJdz'
    break;
  case '10.10.50.180:8000':
    liffId = '1657228471-1b97XOGG';
    lineFriend ='https://line.me/R/ti/p/@687nrcyc'
    bindUrl ='https://liff.line.me/1657228471-QwV5ljGG'
    break;
  case '10.10.50.189:8000':
    liffId = '1657228471-kmJoRz22';
    lineFriend ='https://line.me/R/ti/p/@687nrcyc'
    bindUrl ='https://liff.line.me/1657228471-QwV5ljGG'
    break;
  case '10.10.50.77:8000':
    liffId = '1657228471-9MeQXxRR';
    lineFriend ='https://line.me/R/ti/p/@687nrcyc'
    bindUrl ='https://liff.line.me/1657228471-QwV5ljGG'
    break;
  case 'sam.dev.coolbe.com.tw':
    liffId = '1656178859-p1avR93N';
    break;
}
Vue.prototype.$lineFriend = lineFriend;
Vue.prototype.$bindUrl = bindUrl;
// const liffId = "1656178859-p1avR93N"; // https://sam.dev.coolbe.com.tw/web/member/info/index.html
// const liffId = "1656178859-OPV4XLBJ"; // https://localhost:8000/
// const liffId = "1656302158-ml4M0G63";   // https://starlike-test.coolbe.com.tw/web/member/info/index.html (星裕測試)
// const liffId = '1656334484-2dwBJeY3'; // https://starlike.coolbe.com.tw/web/member/info/index.html (星裕正式)
// const liffId = "1654232699-ODGKr6Ka";

liff.init({ liffId })
  .then(() => {
    if (!liff.isLoggedIn()) {
      localStorage.setItem('desiredPath', window.location.hash);
      liff.login();
    } else {
      handleLiffCallback();
    }
  })
  .catch(error => {
    console.log(error);
  });

function handleLiffCallback() {
  const url = new URL(window.location.href);
  const params = new URLSearchParams(url.search);

  // 獲取並移除不必要的參數
  params.delete('code');
  params.delete('state');
  params.delete('liffClientId');
  params.delete('liffRedirectUri');

  // 構建新的 URL 並替換路徑
  const desiredPath = localStorage.getItem('desiredPath');
  if (desiredPath) {
    history.replaceState(null, '', url.origin + url.pathname + desiredPath);
    localStorage.removeItem('desiredPath'); 
  }

  Promise.all([
    getFriendship(),
    getProfile(),
    getAccessToken()
  ]).then(resolveResult => {
    if (!resolveResult[0].friendFlag) {
      console.error('not friend');
    }

    let uid = resolveResult[1].userId;
    let accessToken = resolveResult[2];
    window.poster = new Api(uid, accessToken);

    window.poster.verify().then(result => {
      document.getElementById('waitingPageLoading').style.display = 'none';
      new Vue({
        router,
        render: h => h(App),
        data() {
          return {
            userData: result.data.data.user,
            uid,
            accessToken,
          }
        },
      }).$mount('#app')
    });
  });
}



